import { CheckCircle2, Flag, Loader2, ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";
import { concernCount } from "@/features/credentials/components/primary-source-runs/run-report-dialog/item-status";
import type {
  SectionTally,
  VerificationSection,
} from "./verification-sections";

function TallyBadge({ tally }: { tally: SectionTally }) {
  if (tally.total === 0) {
    return null;
  }
  let Icon = CheckCircle2;
  let label = "All items accepted";
  let style = "border-green-200 bg-green-50 text-green-800";
  if (tally.concerns > 0) {
    Icon = Flag;
    label = concernCount(tally.concerns);
    style = "border-red-200 bg-red-50 text-red-800";
  } else if (tally.collecting > 0) {
    Icon = Loader2;
    label = `${tally.collecting} collecting`;
    style = "border-blue-200 bg-blue-50 text-blue-800";
  } else if (tally.open > 0) {
    Icon = ShieldAlert;
    label = `${tally.open} need review`;
    style = "border-amber-200 bg-amber-50 text-amber-800";
  }
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold",
        style,
      )}
    >
      <Icon
        className={cn(
          "size-3.5",
          tally.collecting > 0 &&
            tally.concerns === 0 &&
            "motion-safe:animate-spin",
        )}
        aria-hidden
      />
      {label}
    </span>
  );
}

export function SectionHeading({
  section,
  description,
  tally,
}: {
  section: VerificationSection;
  /** Replaces the section's own description, such as the run's state. */
  description?: string;
  tally?: SectionTally;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h2 className="text-xl font-semibold tracking-tight">
          {section.heading}
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {description ?? section.description}
        </p>
      </div>
      {tally && <TallyBadge tally={tally} />}
    </div>
  );
}
